import { RoutePathOutputWithOutStatus } from './route-path-output-with-out-status.model';


export class RoutePathSelectActiveOutput implements IRoutePathSelectActiveOutput {
    status!: number;
    message!: string;
    data!: RoutePathOutputWithOutStatus[];

    constructor(data?: IRoutePathSelectActiveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RoutePathOutputWithOutStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoutePathSelectActiveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePathSelectActiveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRoutePathSelectActiveOutput {
    status: number;
    message: string;
    data: RoutePathOutputWithOutStatus[];
}

